import React from 'react';
import classNames from 'classnames';
import * as styles from './styles/styles.module.scss';

export type Props = {
  className?: string;
};

const PillGroup = ({ className, children }: React.PropsWithChildren<Props>): JSX.Element => (
  <div className={classNames(className, styles.container)}>
    <div className={styles.pills}>{children}</div>
  </div>
);

export default PillGroup;
